@if (!loaded) {
  <tidy-loader [show]="true" />
}

@if (loaded && expired) {
  <tidy-wrapper>
    <tidy-card>
      <tidy-row [align]="'center'">
        <tidy-image [src]="'assets/svg/warning.svg'" class="header-size" />
      </tidy-row>
      <tidy-row [align]="'center'">
        <tidy-text [header]="'Link Expired'" />
      </tidy-row>
      <tidy-row [align]="'center'">
        <tidy-text [body]="'This link is no longer valid. Please contact support for a new one.'" />
      </tidy-row>
    </tidy-card>
  </tidy-wrapper>
}

@if (loaded && errorMessage) {
  <tidy-wrapper>
    <tidy-error-message [text]="errorMessage" />
  </tidy-wrapper>
}
